module.exports = __webpack_public_path__ + "img/Home_Img3.cd778821.png";